export const subscriptionLabel = (status: string) => ({
  Active: 'Active subscription', TestActive: 'Test subscription', Inactive: 'No active subscription',
  NotApplicable: 'N/A — PFV2', AccessUnavailable: 'Access unavailable', TokenUnavailable: 'Token missing',
  SourceMissing: 'Source missing', SourceChanged: 'Source changed', CheckFailed: 'Verification failed',
  Unverified: 'Not verified',
}[status] || 'Not verified');

export const mappingLabel = (status: string) => ({
  Mapped: 'Linked', SourceOnly: 'PFV1 source registered', NotRefreshed: 'Refresh PFV1 inventory',
  InvalidDomain: 'Invalid Shopify domain', AmbiguousDomain: 'Ambiguous domain',
  RehearsalMapping: 'Rehearsal link — review', MappingConflict: 'Mapping conflict', SourceMissing: 'Missing from PFV1',
}[status] || status);

export const hasMappingConflict = (status: string) =>
  ['InvalidDomain', 'AmbiguousDomain', 'RehearsalMapping', 'MappingConflict', 'SourceMissing'].includes(status);

export const storeDomainUrl = (domain?: string): string | null => {
  const value = domain?.trim();
  if (!value || /[\s\\]/.test(value) || value.startsWith('//')) return null;
  try {
    const url = new URL(/^https?:\/\//i.test(value) ? value : `https://${value}`);
    if (!['https:', 'http:'].includes(url.protocol) || !url.hostname.includes('.')
      || url.username || url.password || url.port || url.pathname !== '/' || url.search || url.hash) return null;
    return url.href;
  } catch { return null; }
};
